export default __webpack_public_path__ + "static/media/logo152.8a92fd3a.svg";